export default "__VITE_ASSET__CJYi$46H__"